import React from 'react';
import R from 'ramda';
import _ from 'lodash';
import { getOwnershipTypeName, getMemberNameByUserId } from '../../../utils';
import { PublishesID } from '../../../constants';

const WorkOwnership = ({
  work,
  withPublishers,
  agreement,
  contractBlocks,
  members,
  dealBlocks,
  dealOrigin,
  dealUsersOrigin,
  profile,
  ownershipTypes,
  dealOwner,
}) => {
  let isOwner = false;
  if (dealOwner) {
    isOwner = profile.id === dealOwner.user;
  }

  let licenserIds = agreement.licenser_ids || [];
  const deals = agreement.deals || [];
  const block = R.find(R.propEq('name', 'Licensing Permissions'))(
    contractBlocks
  );

  if (block && block.options) {
    licenserIds = block.options.licenserIds || [];
  }

  if (work.work_ownership_info && work.work_ownership_info.length) {
    const ownerships = R.clone(work.work_ownership_info);

    let deal = R.find(R.propEq('work', work.id))(deals);
    let dealUsers = [];
    if (deal) {
      dealUsers = deal.deal_users || [];
    }

    if (
      dealBlocks &&
      dealOrigin &&
      deal &&
      deal.id === dealOrigin.id &&
      isOwner
    ) {
      // when it's deal work, find deal changes for Overview
      let dealBlock = R.find(R.propEq('id', 0))(dealBlocks);

      if (dealBlock && dealBlock.changes) {
        dealBlock.changes.forEach((change) => {
          if (change) {
            const index = R.findIndex(R.propEq('id', change.id))(ownerships);
            if (index !== -1) {
              let ownership = { ...ownerships[index] };

              if (change.role_ids) {
                ownership.role_ids = change.role_ids;
              }
              if (change.ownership_type) {
                ownership.ownership_type = change.ownership_type;
              }
              if (
                change.percentage !== undefined &&
                ownerships.percentage !== change.percentage
              ) {
                ownership.percentage = change.percentage;
              }

              ownerships[index] = ownership;
            }
          }
        });
      }

      // find deal changes for licensing
      dealBlock = R.find(R.propEq('id', block.id))(dealBlocks);
      if (dealBlock && dealBlock.changes) {
        licenserIds = dealBlock.changes.licenserIds || [];
      }
    }

    const rows = [];
    let i = 0;
    ownerships.forEach(
      ({
        user,
        ownership_type,
        percentage,
        role_ids,
        use_company_name,
        company_name,
        ...otherInfo
      }) => {
        let userName = getMemberNameByUserId(user, members);

        // if (agreement.completed && work.date_accepted) {
        //     userInfo = otherInfo;
        // }

        if (use_company_name && company_name) {
          userName += ` (${company_name})`;
        }

        let publishers = [];
        if (withPublishers) {
          if (dealOrigin && deal && deal.id === dealOrigin.id) {
            dealUsers = dealUsersOrigin;
          }
          const dealUser = R.find(R.whereEq({ user: user, type: 'member' }))(
            dealUsers
          );
          publishers =
            dealUser && dealUser.publishers ? dealUser.publishers : [];

          if (
            dealBlocks &&
            deal &&
            dealOrigin.id === deal.id &&
            (profile.id === user || profile.id === deal.user)
          ) {
            let dealBlock = R.find(R.propEq('id', PublishesID))(dealBlocks);

            if (
              dealBlock &&
              dealBlock.changes &&
              dealBlock.changes.adjust &&
              isOwner
            ) {
              publishers = R.filter(
                (publisher) => publisher.userId === user,
                dealBlock.changes.publishers
              );
            }
          }
        }

        const ownershipType = getOwnershipTypeName(
          ownership_type,
          ownershipTypes
        );

        let contributorData = '';
        if (work.sound_recording_type === 'revenue') {
          contributorData =
            ownershipType === 'No Ownership'
              ? 'No Ownership'
              : `${percentage}% revenue from the ${ownershipType}`;
        } else {
          contributorData =
            ownershipType === 'No Ownership'
              ? 'No Ownership'
              : `${percentage}% ownership of the ${ownershipType}`;
        }

        const permissionToLicense =
          agreement.type === 'premium'
            ? licenserIds.indexOf(user) !== -1
              ? 'Yes'
              : 'No'
            : null;

        rows.push(
          <li key={i}>
            <div>
              <span className="text-blue">{userName}: </span>
              <span>{contributorData}</span>
            </div>
            {publishers.map(
              ({ publisher_name, society, publisher_share }, index) => (
                <div key={index}>
                  {index === 0 && <span>Publisher Share: </span>}
                  <span
                    className={`text-blue ${
                      index !== 0 ? 'duplicate-publisher' : ''
                    }`}
                  >
                    {`${
                      parseFloat(publisher_share, 10) || 0
                    }% ${publisher_name} (${society})`}
                  </span>
                </div>
              )
            )}
            {agreement.type !== 'split' && (
              <div>
                <span>Permission to License: </span>
                <span className="text-blue">{permissionToLicense}</span>
              </div>
            )}
          </li>
        );

        i++;
      }
    );

    return <ul>{rows}</ul>;
  }
};

export default WorkOwnership;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/WorkOwnership.js